import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ServiceForecast } from './service-forecast';

@Component({
  selector: 'app-form-service-forecast',
  templateUrl: './form-service-forecast.component.html',
  styleUrls: ['./form-service-forecast.component.css']
})
export class FormServiceForecastComponent implements OnInit {

  @Input() data: any;
  @Output() service_forecast: EventEmitter<any> = new EventEmitter<any>()
  items: Array<ServiceForecast> = [];

  constructor() { }

  ngOnInit(): void {
    if (this.data) {
      this.push(this.data)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.data.currentValue) {
      this.push(changes.data.currentValue);
    }
  }
  push(data: any) {
    data.forEach(element => {

      let item = new ServiceForecast();

      item.id             = element.id;
      item.ml_report_id   = element.ml_report_id;
      item.date           = element.date;
      item.observation    = element.observation;

      this.items.push(item);
    });
  }

  newItem() {
    let sf = new ServiceForecast();
    sf.ml_report_id = null;
    this.items.push(sf);
    this.service_forecast.emit(this.items);
  }

  send() {
    this.service_forecast.emit(this.items);
  }

  destroy(item) {
    let index = this.items.indexOf(item);
    this.items.splice(index, 1);
  }

}
